import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || ''

// Valores por defecto: se usan mientras carga la API o si no responde.
// Los valores reales se editan desde el panel de administración (/admin/ajustes)
// y los sirve el backend en GET /api/config/.
export const CONTACTO_DEFAULT = {
  telefono: '+34 623 49 86 48',
  email: 'Elrincondelaescandella2025@gmail.com',
  direccion: 'Dentro de Cerámica La Escandella\nC. Bélgica, 1 · 03698 Agost (Alicante)',
  horario: 'Lun – Vie: 07:30 – 16:00\nSábados: 07:30 – 12:30\nDomingos: cerrado',
  busqueda_maps: 'Cerámica La Escandella S.A., Agost, Alicante',
  menu_dia_precio: '13,00 €',
}

export const CAMPOS = [
  { clave: 'telefono', label: 'Teléfono', ayuda: 'Tal como quieres que se vea, p. ej. +34 623 49 86 48', multilinea: false },
  { clave: 'email', label: 'Email de contacto', ayuda: 'Aparece en Contacto y Alérgenos', multilinea: false },
  { clave: 'direccion', label: 'Dirección', ayuda: 'Una línea por renglón', multilinea: true },
  { clave: 'horario', label: 'Horario', ayuda: 'Una línea por renglón', multilinea: true },
  { clave: 'busqueda_maps', label: 'Lugar en Google Maps', ayuda: 'Lo que se busca en el mapa y en "Cómo llegar"', multilinea: false },
  { clave: 'menu_dia_precio', label: 'Precio del menú del día', ayuda: 'p. ej. 13,00 €', multilinea: false },
]

// Solo dígitos y el "+" inicial, para el enlace tel:
export const telefonoEnlace = (t) => (t || '').replace(/[^\d+]/g, '')
export const lineas = (t) => (t || '').split('\n').map(l => l.trim()).filter(Boolean)
export const urlComoLlegar = (q) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`
export const urlMapaEmbed = (q) => `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed&hl=es`

let cache = null

/** Devuelve los datos de contacto (por defecto y luego los reales de la API). */
export function useContacto() {
  const [contacto, setContacto] = useState(cache || CONTACTO_DEFAULT)
  useEffect(() => {
    if (cache) return
    axios.get(`${API}/api/config/`)
      .then(res => { cache = { ...CONTACTO_DEFAULT, ...res.data }; setContacto(cache) })
      .catch(() => { /* se queda con los valores por defecto */ })
  }, [])
  return contacto
}

export function invalidarContacto() { cache = null }
